import { render, staticRenderFns } from "./finishedTopic.vue?vue&type=template&id=04ed6927&scoped=true&"
import script from "./finishedTopic.vue?vue&type=script&lang=js&"
export * from "./finishedTopic.vue?vue&type=script&lang=js&"
import style0 from "./finishedTopic.vue?vue&type=style&index=0&id=04ed6927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed6927",
  null
  
)

export default component.exports